import Footer from "../components/footer";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import SideNavReSeller from "../components/sidenavReSeller";
import React, { useState, useEffect, useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const EditProfileReSeller = ()=>{

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const navigate = useNavigate();
    const [newdata, setNewdata] = useState({
        address:'', city: '', state: '', country: '', pin: '', gst: '', tradeName: '', aadhar: '', 
        contact: '', username: '', email: '', mobile: '', userType: '', userStatus: '', 
        featured_artist: '', image: '',
        about: '', awards: '', shows: '', exhibition: ''
    });

    // Function to Fetch data from API for dropdown
    const fetchData = useCallback(async (url, setData) => {
        
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    // Modified useEffect for data fetching
    useEffect(() => {
        if (userInfo.user_id) {
            
            fetchData(`https://igapi.heuristticminds.com/api/UsersList/Get-GetUserAddressByUserID?User_ID=` + userInfo.user_id, (data) => {
            
            if(data)
            {
                
            const addressData = data;
            if(addressData)
            {
                setNewdata(prevData => ({
                    ...prevData,
                    address: addressData.address,
                    city: addressData.city,
                    state: addressData.state,
                    country: addressData.country,
                    pin: addressData.pin,
                    gst: addressData.gst,
                    tradeName: addressData.tradeName,
                    aadhar: addressData.aadhar,
                    contact: addressData.contact,
                    username: addressData.username, 
                    email: addressData.email, 
                    mobile: addressData.mobile, 
                    userType: addressData.userType, 
                    userStatus: addressData.userStatus, 
                    featured_artist: addressData.featured_artist, 
                    image: addressData.image,
                }));
               
            }
            }
            });
        }
    }, [userInfo.user_id, fetchData]);
    

    // Set focus on the "Full Name" input when the component mounts
    const handleAddressChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            address: event.target.value
        }));
    };
    const handleCityChange = (event) => {
        const value = event.target.value;
        // Allow only alphabetic characters and spaces
        if (/^[a-zA-Z\s]*$/.test(value) || value === '') {
            setNewdata(prevData => ({
                ...prevData,
                city: value
            }));
        }
    };
    const handleStateChange = (event) => {
        const value = event.target.value;
        // Allow only alphabetic characters and spaces
        if (/^[a-zA-Z\s]*$/.test(value) || value === '') {
            setNewdata(prevData => ({
                ...prevData,
                state: value
            }));
        }
    };
    const handleCountryChange = (event) => {
        const value = event.target.value;
        // Allow only alphabetic characters and spaces
        if (/^[a-zA-Z\s]*$/.test(value) || value === '') {
            setNewdata(prevData => ({
                ...prevData,
                country: value
            }));
        }
    };
    const handlePINChange = (event) => {
        const value  = event.target.value;
        // Check if the value is numeric and has a length of up to 6 characters
        if (value === '' || (/^\d+$/.test(value) && value.length <= 6)) {
            setNewdata(prevData => ({
                ...prevData,
                pin: value
            }));
        }
    };
    const handleAadharChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            aadhar: event.target.value
        }));
    };
    const handleContactChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            contact: event.target.value
        }));
    };
    const handleGSTChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            gst: event.target.value
        }));
    };
    const handleTradeChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            tradeName: event.target.value
        }));
    };
 
    

    const handleSubmit = async(event) => {
        event.preventDefault();

            const formData = {

            "id": userInfo.user_id,
            "address": newdata.address,
            "city": newdata.city,
            "state": newdata.state,
            "country": newdata.country,
            "pin": newdata.pin,
            "gst": newdata.gst,
            "tradeName": newdata.tradeName,
            "aadhar": newdata.aadhar,
            "contact": newdata.contact,
            "createdBy": userInfo.user_id
        };
        try {
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/UsersList/Add-SaveUserAddress', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                const confirmed = window.confirm("Address Saved Successfully !!");
                if (!confirmed) {
                    return; // If not confirmed, return early without deleting
                }
                navigate('/viewProfileReSeller');

            } else {
                const confirmed = window.confirm("Address Not Saved !!");
                if (!confirmed) {
                    return; // If not confirmed, return early without deleting
                }
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }

    };

    return(
        <>
         <Header />
            <div id="layoutSidenav">
                <SideNavReSeller />
                <div id="layoutSidenav_content">

                    <PageHeader name='Add Profile' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Add / Update Profile</div>
                                    <div className="card-body">
                                        <NavLink className="btn btn-primary float-end" to={`/viewProfileReSeller`}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                        <div className="clearfix"></div>
                                        

                                            {/* Address Form */}
                                        <form>
                                        <div className={`p-4 pt-2`}>                                                
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                {newdata.image && (
                                                    <img className="m-2" src={`../images/profile/${newdata.image}`} alt="" width="100px" />
                                                    )}
                                                </div>
                                                <div className="col-sm-6 form-group mb-3">
                                                        <label>Address*</label>
                                                        <textarea type="text"
                                                            name="address"
                                                            id="address"
                                                            value={newdata.address}
                                                            maxLength={200}
                                                            rows = {2}
                                                            className="form-control"
                                                            onChange={handleAddressChange}
                                                            placeholder="Enter Address" required />                                                        

                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                <h4><label> {newdata.username}</label>  </h4><label>({newdata.userType})</label>
                                                </div>
                                                <div className="col-sm-3 form-group mb-3">
                                                        <label>City*</label>
                                                        <input type="text"
                                                            name="city"
                                                            id="city"
                                                            value={newdata.city}
                                                            maxLength={20}
                                                            className="form-control"
                                                            onChange={handleCityChange}
                                                            placeholder="Enter City" required />                                                        

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>State*</label>
                                                        <input type="text"
                                                            name="state"
                                                            id="state"
                                                            value={newdata.state}
                                                            maxLength={20}
                                                            className="form-control"
                                                            onChange={handleStateChange}
                                                            placeholder="Enter State" required />                                                        

                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Email ID : </label>
                                                        <label>{newdata.email}</label>  
                                                </div>
                                                <div className="col-sm-3 form-group mb-3">
                                                        <label>Country*</label>
                                                        <input type="text"
                                                            name="country"
                                                            id="country"
                                                            value={newdata.country}
                                                            maxLength={20}
                                                            className="form-control"
                                                            onChange={handleCountryChange}
                                                            placeholder="Enter Country" required />                                                        

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>PIN/ZIP Code*</label>
                                                        <input type="text"
                                                            name="pin"
                                                            id="pin"
                                                            value={newdata.pin}
                                                            maxLength={6}
                                                            className="form-control"
                                                            onChange={handlePINChange}
                                                            placeholder="Enter PIN" required />                                                        

                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Mobile : </label>
                                                        <label>{newdata.mobile}</label>  
                                                    </div>
                                                <div className="col-sm-3 form-group mb-3">
                                                        <label>Aadhar</label>
                                                        <input type="text"
                                                            name="aadhar"
                                                            id="aadhar"
                                                            value={newdata.aadhar}
                                                            maxLength={12}
                                                            className="form-control"
                                                            onChange={handleAadharChange}
                                                            placeholder="Enter Aadhar"/>                                                      

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                    <label>Alternate Contact No</label>
                                                        <input type="text"
                                                            name="contact"
                                                            id="contact"
                                                            value={newdata.contact}
                                                            maxLength={15}
                                                            className="form-control"
                                                            onChange={handleContactChange}
                                                            placeholder="Enter Alternate Contact" />                                                   

                                                    </div>
                                                </div>
                                                <div className="row">
                                                        <div className="col-sm-3 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Status : </label>
                                                        <label>{newdata.userStatus}</label> 
                                                        </div>
                                                        <div className="col-sm-3 form-group mb-3">
                                                        {/* <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Featured Artist : </label>
                                                        <label>{newdata.featured_artist}</label>  */}  
                                                        </div>
                                                        <div className="col-sm-3 form-group mb-3">
                                                        <label>GSTIN</label>
                                                        <input type="text"
                                                            name="gst"
                                                            id="pan"
                                                            value={newdata.gst}
                                                            maxLength={15}
                                                            className="form-control"
                                                            onChange={handleGSTChange}
                                                            placeholder="Enter GSTIN" />   
                                                    </div>                                                     
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Trade Name</label>
                                                        <input type="text"
                                                            name="tradeName"
                                                            id="tradeName"
                                                            value={newdata.tradeName}
                                                            maxLength={100}
                                                            className="form-control"
                                                            onChange={handleTradeChange}
                                                            placeholder="Enter Trade Name" />   
                                                    </div>
                                                    
                                                    
                                                </div>
                                                
                                                <div className="row">
                                                <div className="col-sm-9 form-group mt-3"></div>
                                                
                                                    <div className="col-sm-3 form-group mt-3">
                                                        {
                                                            <button type="submit"
                                                                onClick={handleSubmit}
                                                                className="btn btn-primary w-50">Submit</button>
                                                        }


                                                    </div>
                                                </div>
                                        </div>
                                        </form>
                                       
                                        </div>
                                    </div>




                                </div>

                            </div>
                        
                    <Footer />
                </div>
                </div>
            </div>       
        </>
    );
};
export default EditProfileReSeller;